import { useState, useMemo, memo } from 'react';

import { useOtpVerify, useNewSecrets } from './hooks';
import { REGENERATE_SECRETS_STEPS } from './interfaces';

import { InfoStep, OtpVerificationStep, NewSecrets } from './steps';

interface Props {
  handleClose: () => void;
  handleLock: () => void;
  handleUnlock: () => void;
}

const ClientSecretsRegeneration = ({ handleClose, handleLock, handleUnlock }: Props) => {
  const { otpVerifyLoading, otpVerifyError, handleOtpVerify } = useOtpVerify();
  const { clientId, clientSecret, handleNewSecrets } = useNewSecrets();
  const [step, setStep] = useState<REGENERATE_SECRETS_STEPS>(REGENERATE_SECRETS_STEPS.INFO);
  const [shortcodeToDial, setShortcodeToDial] = useState<string>();
  const [userMsisdnFromBackend, setUserMsisdnFromBackend] = useState<string>();

  const DialogForm = useMemo(() => {
    switch (step) {
      case REGENERATE_SECRETS_STEPS.INFO:
        handleUnlock();

        return (
          <InfoStep
            onClose={handleClose}
            onSubmit={(ussdShortcode?: string, userMsisdn?: string) => {
              setShortcodeToDial(ussdShortcode);
              setUserMsisdnFromBackend(userMsisdn);
              setStep(REGENERATE_SECRETS_STEPS.OTP_VERIFICATION);
            }}
          />
        );
      case REGENERATE_SECRETS_STEPS.OTP_VERIFICATION:
        return (
          <OtpVerificationStep
            shortcodeToDial={shortcodeToDial}
            userMsisdnFromBackend={userMsisdnFromBackend}
            onClose={handleClose}
            loading={otpVerifyLoading}
            onSubmit={otp => {
              handleOtpVerify(otp, secrets => {
                handleNewSecrets(secrets);
                setStep(REGENERATE_SECRETS_STEPS.NEW_SECRETS);
              });
            }}
            error={otpVerifyError}
          />
        );
      case REGENERATE_SECRETS_STEPS.NEW_SECRETS:
        if (clientId && clientSecret) {
          handleLock();
          return (
            <NewSecrets
              clientId={clientId}
              clientSecret={clientSecret}
              handleClose={handleClose}
              handleUnlock={handleUnlock}
              handleLock={handleLock}
            />
          );
        }

        return null;
      default:
        handleUnlock();
        handleClose();
        return null;
    }
  }, [
    clientId,
    clientSecret,
    handleClose,
    handleLock,
    handleNewSecrets,
    handleOtpVerify,
    handleUnlock,
    otpVerifyError,
    otpVerifyLoading,
    shortcodeToDial,
    step,
    userMsisdnFromBackend
  ]);

  return <>{DialogForm}</>;
};

export default memo(ClientSecretsRegeneration);
